module.exports = __webpack_public_path__ + "static/img/zcbiao.f941061.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/zcbiao.jpg
// module id = ncrM
// module chunks = 1